

import * as api from "../constant/NewAPI";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Column } from "primereact/column";
import Select from "react-select";
// import * as XLSX from "xlsx";
import * as XLSX from "xlsx-js-style";
import { all_routes } from "../router/all_routes";
import Utils from "../constant/Utils";
import Swal from "sweetalert2";

// import * as api from "../constant/API";

const assessmentReport = () => {

    const routes = all_routes;

    const userId = localStorage.getItem('UserId');
    const roleId = localStorage.getItem('RoleId');

    const [searchInput, setSearchInput] = useState('');
    const [instituteList, setInstituteList] = useState([]);
    const [assessmentTypeList, setAssessmentTypeList] = useState([]);
    const [groupList, setGroupList] = useState([]);
    const [batchList, setBatchList] = useState([]);
    const [studList, setStudList] = useState([]);
    const [reportList, setReportList] = useState([]);
    const [detailsList, setDetailsList] = useState([]);
    const [groupId, setGroupId] = useState('');
    const [institutionId, setInstitutionId] = useState('');
    const [batchId, setBatchId] = useState('');
    const [studId, setStudId] = useState('');
    const [assessmentTypeId, setAssessmentTypeId] = useState('');
    const [reportTypeId, setReportTypeId] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [showTable, setShowTable] = useState(false);

    const reportType = [
        { label: "Institute", value: "1" },
        { label: "By Batch", value: "2" },
        { label: "By Student", value: "3" }
    ];

    useEffect(() => {
        instList()
    }, [])

    function instList() {
        const institute = api.InstitutionList;
        fetch(institute, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((instReponse) => instReponse.json())
            .then((instResult) => {
                if (instResult.error == true) {
                    if (instResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(instResult.message)
                } else {
                    if (instResult.data != null) {
                        setInstituteList(instResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch institution list", error)
            })
    }

    function getassessmentTypeList() {
        const asmntTyp = api.adminAssessmentList;
        fetch(asmntTyp, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((typResponse) => typResponse.json())
            .then((typResult) => {
                if (typResult.error == false) {
                    setAssessmentTypeList(typResult.data)
                }
                else {
                    Swal.fire(typResult.message)
                    if (typResult.code == 401) {
                        Utils.logoutUser();
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch the assessment type list", error);
            })
    }

    function getStudList() {
        const studlst = api.AsmntRprtStudentsByBatch + '/' + institutionId;
        fetch(studlst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((studResponse) => studResponse.json())
            .then((studResult) => {
                if (studResult.error == true) {
                    if (studResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (studResult.data != null) {
                        setStudList(studResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch student list", error)
            })
    }

    function getBatchList() {
        const getbtchlst = api.AsmntRprtBatchesByInst + '/' + roleId + '/' + institutionId;
        fetch(getbtchlst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((btchResponse) => btchResponse.json())
            .then((btchResult) => {
                if (btchResult.error == true) {
                    if (btchResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    if (btchResult.data != null) {
                        setBatchList(btchResult.data)
                    }
                }
            })
            .catch((error) => {
                console.log("Failed to fetch batch list.", error)
            })
    }

    function assessReport() {
        let atendncReport = api.YfhAssessmentReport + '/' + institutionId + '/' + fromDate + '/' + toDate + '/' + reportTypeId;
        if (batchId) {
            atendncReport += '/' + batchId;
        } else if (studId) {
            atendncReport += '/' + studId;
        }
        fetch(atendncReport, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((asmntResponse) => asmntResponse.json())
            .then((asmntResult) => {
                if (asmntResult.error == true) {
                    if (asmntResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(asmntResult.message)
                } else {
                    if (asmntResult.data != null) {
                        setReportList(asmntResult.data.assessment)
                    }
                    // setReportList(asmntResult.data)
                    setShowTable(true)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch report list", error);
            })
    }

    function showDetails(itm) {
        const scdlId = itm.assessmentScheduleId;
        const assessmentDetails = api.ReportAssessmentData + '/' + batchId + '/' + assessmentTypeId + '/' + scdlId + '/' + institutionId //+ "?batchName=" + batchId + "&Institute=" + institutionId + "&assessmentName=" + assessmentId + "&assessmentId=" + asmntId + "&schedule=" + scdlId;
        fetch(assessmentDetails, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((dtlsResponse) => dtlsResponse.json())
            .then((dtlsResult) => {
                if (dtlsResult.error == false) {
                    setDetailsList(dtlsResult.data)
                } else {
                    if (dtlsResult.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(dtlsResult.message)
                }
                // setDetailsList(dtlsResult.data)
            })
    }

    function exportnow() {
        let exprt = api.YfhAssessmentReportExport + '/' + institutionId + '/' + fromDate + '/' + toDate + '/' + reportTypeId;
        if (batchId) {
            exprt += '/' + batchId;
        } else if (studId) {
            exprt += '/' + studId;
        }
        fetch(exprt, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((exportReponse) => exportReponse.json())
            .then((exportResult) => {
                if (exportResult.error == true) {
                    if (exportResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    // if (reportTypeId === '1') {
                    exportToExcel(exportResult.data)
                    // } else {
                    //     const blob = new Blob([exportResult.data], { type: "application/vnd.ms-excel" });
                    //     const url = URL.createObjectURL(blob);
                    //     const a = document.createElement("a");
                    //     a.href = url;
                    //     a.download = "AssessmentReport.xls"; // Save file as .xls
                    //     document.body.appendChild(a);
                    //     a.click();
                    //     document.body.removeChild(a);
                    //     URL.revokeObjectURL(url);
                    // }
                }
            })
            .catch((error) => {
                console.log("Failed to export Assessment Report", error);
            })
    }

    function exportToExcel(apiData) {
        const wb = XLSX.utils.book_new();
        const parser = new DOMParser();

        const dataObj =
            typeof apiData === "string"
                ? { Sheet1: apiData }
                : apiData;

        Object.keys(dataObj).forEach((teamKey) => {
            const htmlString = dataObj[teamKey];
            const doc = parser.parseFromString(htmlString, "text/html");

            const sheetData: any[] = [];
            let colCount = 0;
            const merges: XLSX.Range[] = [];

            // ✅ Track per-table ranges
            const tableRanges: { start: number; end: number; colCount: number }[] = [];

            // ===== H2 Titles =====
            const h2Tags = doc.querySelectorAll("h2");
            h2Tags.forEach((h2) => {
                const text = h2.textContent?.trim();
                if (text) {
                    sheetData.push([text]);
                    sheetData.push([]);
                }
            });

            const headings = doc.querySelectorAll("h3");
            const tables = doc.querySelectorAll("table");

            tables.forEach((table, index) => {
                const heading = headings[index]?.textContent?.trim();

                if (heading) {
                    sheetData.push([heading]);
                }

                const rows = table.querySelectorAll("tr");

                const grid: any[][] = [];
                const startRow = sheetData.length;

                rows.forEach((row, rIndex) => {
                    if (!grid[rIndex]) grid[rIndex] = [];

                    let colIndex = 0;
                    const cols = row.querySelectorAll("th, td");

                    cols.forEach((col) => {
                        while (grid[rIndex][colIndex] !== undefined) {
                            colIndex++;
                        }

                        const rowspan = parseInt(col.getAttribute("rowspan") || "1");
                        const colspan = parseInt(col.getAttribute("colspan") || "1");

                        const value = col.textContent?.trim() || "";

                        grid[rIndex][colIndex] = value;

                        if (rowspan > 1 || colspan > 1) {
                            merges.push({
                                s: { r: startRow + rIndex, c: colIndex },
                                e: {
                                    r: startRow + rIndex + rowspan - 1,
                                    c: colIndex + colspan - 1
                                }
                            });
                        }

                        // Fill placeholders for merged cells
                        for (let i = 0; i < rowspan; i++) {
                            for (let j = 0; j < colspan; j++) {
                                if (i === 0 && j === 0) continue;

                                if (!grid[rIndex + i]) grid[rIndex + i] = [];
                                grid[rIndex + i][colIndex + j] = null;
                            }
                        }

                        colIndex += colspan;
                    });
                });

                // ✅ Track table-specific column count
                const tableStart = sheetData.length;
                let tableColCount = 0;

                grid.forEach((row) => {
                    tableColCount = Math.max(tableColCount, row.length);
                    colCount = Math.max(colCount, row.length);
                    sheetData.push(row);
                });

                const tableEnd = sheetData.length - 1;

                tableRanges.push({
                    start: tableStart,
                    end: tableEnd,
                    colCount: tableColCount
                });

                sheetData.push([]);
                sheetData.push([]);
            });

            // ===== Create Worksheet =====
            const ws = XLSX.utils.aoa_to_sheet(sheetData);

            // ===== Styles =====
            const borderStyle = {
                top: { style: "thin" },
                bottom: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" }
            };

            Object.keys(ws).forEach((cellRef) => {
                if (cellRef[0] === "!") return;

                const cell = ws[cellRef];
                const address = XLSX.utils.decode_cell(cellRef);
                const row = sheetData[address.r];

                if (!row) return;

                const isTitle = row.length === 1;

                const isHeader =
                    row.includes("Sl. No.") ||
                    row.includes("Result") ||
                    row.includes("Grade");

                const isTableRow = row.length > 3;

                cell.t = "s";
                cell.s = {
                    alignment: {
                        horizontal: address.c === 1 ? "left" : "center",
                        vertical: "center",
                        wrapText: true
                    }
                };

                // ✅ Borders only for table rows
                if (isTableRow) {
                    cell.s.border = borderStyle;
                }

                if (isHeader) {
                    cell.s.fill = { fgColor: { rgb: "D9D9D9" } };
                    cell.s.font = { bold: true };
                }

                if (isTitle) {
                    cell.s.font = { bold: true, sz: 14 };
                }

                // if (cell.v === "A") {
                //     cell.s.font = {
                //         ...(cell.s.font || {}),
                //         color: { rgb: "FF0000" },
                //         bold: true
                //     };
                // }
            });

            // ===== ✅ Merge Titles (SMART LOGIC) =====
            sheetData.forEach((row, i) => {
                if (row.length !== 1) return;

                let table = null;

                // 1. Inside/near a table
                table = tableRanges.find(t => i >= t.start - 2 && i <= t.end);

                // 2. Before first table
                if (!table && tableRanges.length > 0 && i < tableRanges[0].start) {
                    table = tableRanges[0];
                }

                // 3. After tables → use closest previous
                if (!table) {
                    for (let j = tableRanges.length - 1; j >= 0; j--) {
                        if (i > tableRanges[j].end) {
                            table = tableRanges[j];
                            break;
                        }
                    }
                }

                if (table && table.colCount > 1) {
                    merges.push({
                        s: { r: i, c: 0 },
                        e: { r: i, c: table.colCount - 1 }
                    });
                }
            });

            // ===== Apply merges =====
            ws["!merges"] = merges;

            // ===== Fix merged cell borders (skip titles) =====
            merges.forEach((merge) => {
                for (let r = merge.s.r; r <= merge.e.r; r++) {
                    const row = sheetData[r];

                    // ❌ Skip title rows
                    if (row && row.length === 1) continue;

                    for (let c = merge.s.c; c <= merge.e.c; c++) {
                        const cellRef = XLSX.utils.encode_cell({ r, c });

                        if (!ws[cellRef]) {
                            ws[cellRef] = { t: "s", v: "" };
                        }

                        if (!ws[cellRef].s) {
                            ws[cellRef].s = {};
                        }

                        ws[cellRef].s.border = borderStyle;
                    }
                }
            });

            // ===== Column Width =====
            const colWidths = [];

            // for (let c = 0; c < colCount; c++) {
            //     let maxLength = 10;

            //     sheetData.forEach((row) => {
            //         if (row.length === 1) return;
            //         const cell = row[c];
            //         if (cell) {
            //             maxLength = Math.max(maxLength, cell.toString().length);
            //         }
            //     });

            //     colWidths.push({ wch: maxLength + 2 });
            // }

            for (let c = 0; c < colCount; c++) {
                if (c === 1) {
                    colWidths.push({ wch: 20 }); // Student Name
                } else if (c === 2 || c === 3) {
                    colWidths.push({ wch: 7 }); // Class & Gender
                } else {
                    colWidths.push({ wch: 8 }); // rest of the columns
                }
            }

            ws["!cols"] = colWidths;

            // ===== Sheet Name =====
            const sheetName = teamKey
                .replace(/[\\?*:[\]/]/g, "")
                .substring(0, 30);

            XLSX.utils.book_append_sheet(wb, ws, sheetName);
        });

        // Export
        XLSX.writeFile(wb, "Assessment Report.xlsx");

    }

    const detailsRender = (rowData) => {
        return (
            <Link to="#" data-bs-toggle="modal" data-bs-target="#assessment-list" onClick={() => { showDetails(rowData); }}>
                <i className="feather feather-eye"></i>View
            </Link>
        );
    };

    const filteredData = reportList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const filteredAssessment = detailsList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchQuery.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        // return <span>{rowData.yfhAssessmentId}</span>
        return column.rowIndex + 1;

    };

    const studentRender = (rowData, column) => {
        return <span>{rowData.student}</span>
    };

    const dateRender = (rowData, column) => {
        return <span>{formatDate(rowData.scheduleDate)}</span>
    };

    const assessmentTypeRender = (rowData, column) => {
        return <span>{rowData.assessmentType}</span>
    };

    const skillRender = (rowData, column) => {
        return <span>{rowData.yfhSkillsName}</span>
    };

    const resultRender = (rowData, column) => {
        return <span>{rowData.yfhAssessmentResult}</span>
    };

    const gradeRender = (rowData, column) => {
        return <span>{rowData.yfhAssessmentGrade}</span>
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">
                                    <i className="fa fa-university"></i>
                                    Assessment Report
                                </h3>
                            </div>
                            <div>
                                <Link
                                    to={routes.reports}
                                    className="btn btn-primary save-profile"
                                >
                                    <i className="fas fa-arrow-left"></i>Back
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="court-tab-content">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row align-items-center">
                                                            <div className="row col-lg-12">
                                                                <div className="row col-lg-12 court-sortby sortbyset">
                                                                    {/* <div className="col-lg-4">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Institute Group</h6></label>
                                                                            <Select
                                                                                value={groupList.find(grp => grp.institutionGroupId === groupId) ? {
                                                                                    value: groupId,
                                                                                    label: groupList.find(grp => grp.institutionGroupId === groupId).institutionGroupName
                                                                                } : null}
                                                                                onChange={(e) => {
                                                                                    setGroupId(e.value);
                                                                                    getInstitutes(e.value)
                                                                                }}
                                                                                options={groupList.map(grp => ({
                                                                                    value: grp.institutionGroupId,
                                                                                    label: grp.institutionGroupName
                                                                                }))}>
                                                                            </Select>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-4">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Institute</h6></label>
                                                                            <Select value={instituteList.find(inst => inst.institutionId === institutionId) ? {
                                                                                value: institutionId,
                                                                                label: instituteList.find(inst => inst.institutionId === institutionId).institutionName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setInstitutionId(e.value)
                                                                                    getBatchList(e.value)
                                                                                }}
                                                                                options={instituteList.map(inst => ({
                                                                                    value: inst.institutionId,
                                                                                    label: inst.institutionName
                                                                                }))}
                                                                                placeholder={"Select Institute"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-4">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Batch</h6></label>
                                                                            <Select value={batchList.find(btch => btch.batchId === batchId) ? {
                                                                                value: batchId,
                                                                                label: batchList.find(btch => btch.batchId === batchId).batchName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setBatchId(e.value)
                                                                                    getAssessmentList();
                                                                                }}
                                                                                options={batchList.map(btch => ({
                                                                                    value: btch.batchId,
                                                                                    label: btch.batchName
                                                                                }))}
                                                                                placeholder={"Select Batch"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-4">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Assessment</h6></label>
                                                                            <Select value={assessmentList.find(asmnt => asmnt.assessmentTypeId === assessmentId) ? {
                                                                                value: assessmentId,
                                                                                label: assessmentList.find(asmnt => asmnt.assessmentTypeId === assessmentId).assessmentType
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setAssessmentId(e.value)
                                                                                }}
                                                                                options={assessmentList.map(asmnt => ({
                                                                                    value: asmnt.assessmentTypeId,
                                                                                    label: asmnt.assessmentType
                                                                                }))}
                                                                                placeholder={"Select Assessment"}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-4 mb-10">
                                                                        <label className="sortbytitle"><h6>From Date</h6></label>
                                                                        <input className="col-md-12" type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={fromDate} onChange={(e) => setFromDate(e.target.value)}></input>
                                                                    </div>
                                                                    <div className="col-lg-4 mb-10">
                                                                        <label className="sortbytitle"><h6>To Date</h6></label>
                                                                        <input className="col-md-12" type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={toDate} onChange={(e) => setToDate(e.target.value)}></input>
                                                                    </div> */}
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>Institute</h6></label>
                                                                        <Select value={instituteList.find(inst => inst.institutionId === institutionId) ? {
                                                                            value: institutionId,
                                                                            label: instituteList.find(inst => inst.institutionId === institutionId).institutionName
                                                                        } : null}
                                                                            onChange={(e) => {
                                                                                setInstitutionId(e.value)
                                                                            }}
                                                                            options={instituteList.map(inst => ({
                                                                                value: inst.institutionId,
                                                                                label: inst.institutionName
                                                                            }))}
                                                                            placeholder={"Select Institute"}
                                                                        />
                                                                    </div>
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>Report Type</h6></label>
                                                                        <Select value={reportType.find(atnd => atnd.value === reportTypeId) ? {
                                                                            value: reportTypeId,
                                                                            label: reportType.find(atnd => atnd.value === reportTypeId).label
                                                                        } : null}
                                                                            onChange={(e) => {
                                                                                setReportTypeId(e.value)
                                                                                getassessmentTypeList();
                                                                                setStudId('')
                                                                                setBatchId('')
                                                                                { e.value === '2' ? getBatchList() : e.value === '3' ? getStudList() : (setBatchList([]), setStudList([])) }
                                                                            }}
                                                                            options={reportType.map(atnd => ({
                                                                                value: atnd.value,
                                                                                label: atnd.label
                                                                            }))}
                                                                            placeholder={"Select Report Type"}
                                                                        />
                                                                    </div>
                                                                    {reportTypeId === '2' && (
                                                                        <div className="col-lg-3 mb-10">
                                                                            <label className="sortbytitle"><h6>Batch</h6></label>
                                                                            <Select value={batchList.find(btch => btch.batchId === batchId) ? {
                                                                                value: batchId,
                                                                                label: batchList.find(btch => btch.batchId === batchId).batchName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setBatchId(e.value)
                                                                                    setStudId('')
                                                                                    // setInstitutionId('')
                                                                                }}
                                                                                options={batchList.map(btch => ({
                                                                                    value: btch.batchId,
                                                                                    label: btch.batchName
                                                                                }))}
                                                                                placeholder={"Select Batch"}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    {reportTypeId === '3' && (
                                                                        <div className="col-lg-3 mb-10">
                                                                            <label className="sortbytitle"><h6>Student</h6></label>
                                                                            <Select value={studList.find(stud => stud.coreUserId === studId) ? {
                                                                                value: studId,
                                                                                label: studList.find(stud => stud.coreUserId === studId).coreUserName
                                                                            } : null}
                                                                                onChange={(e) => {
                                                                                    setStudId(e.value)
                                                                                    setBatchId('')
                                                                                    // setInstitutionId('')
                                                                                }}
                                                                                options={studList.map(stud => ({
                                                                                    value: stud.coreUserId,
                                                                                    label: stud.coreUserName
                                                                                }))}
                                                                                placeholder={"Select Student"}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                    {/* <div className="col-md-3 mb-10">
                                                                        <label className="sortbytitle"><h6>Assessment Type</h6></label>
                                                                        <Select value={assessmentTypeList.find(typ => typ.assessmentTypeId === assessmentTypeId) ? {
                                                                            value: assessmentTypeId,
                                                                            label: assessmentTypeList.find(bch => bch.assessmentTypeId === assessmentTypeId).assessmentType
                                                                        } : null}
                                                                            onChange={(e) => {
                                                                                setAssessmentTypeId(e.value)
                                                                            }}
                                                                            options={assessmentTypeList.map(typ => ({
                                                                                value: typ.assessmentTypeId,
                                                                                label: typ.assessmentType
                                                                            }))}
                                                                            placeholder="Select an Assessment Type"
                                                                        />
                                                                    </div> */}
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>From Date</h6></label>
                                                                        <input className="col-md-12" type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={fromDate} onChange={(e) => setFromDate(e.target.value)}></input>
                                                                    </div>
                                                                    <div className="col-lg-3 mb-10">
                                                                        <label className="sortbytitle"><h6>To Date</h6></label>
                                                                        <input className="col-md-12" type="date" style={{ border: "1px solid hsl(0, 0%, 80%)", borderRadius: "4px", minHeight: "38px" }} value={toDate} onChange={(e) => setToDate(e.target.value)}></input>
                                                                    </div>
                                                                    <div className="col-lg-6">
                                                                        <div className="save-changes text-sm mt-4">
                                                                            <Link
                                                                                to="#"
                                                                                className="btn btn-primary save-profile"
                                                                                onClick={assessReport}
                                                                            >
                                                                                Submit
                                                                            </Link>
                                                                            <Link
                                                                                to="#"
                                                                                className={`btn btn-primary save-profile`}
                                                                                onClick={exportnow}
                                                                            >
                                                                                Export to Excel
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-lg-12 border-bottom" style={{ marginTop: "1rem", marginBottom: "1rem" }} />
                                                                    {showTable && (
                                                                        <>
                                                                            <div className="col-lg-12">
                                                                            </div>
                                                                            <div className="col-lg-12">
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                            </div>
                                                                            <div className="col-lg-6">
                                                                                <div className="dataTables_filter">
                                                                                    <label>
                                                                                        <input
                                                                                            type="text"
                                                                                            value={searchInput}
                                                                                            onChange={(e) => setSearchInput(e.target.value)}
                                                                                            placeholder="Search"
                                                                                            className="form-control"
                                                                                        />
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )}

                                                                </div>
                                                            </div>
                                                            {showTable && (
                                                                <>
                                                                    <div className="tab-content mt-2">
                                                                        <div
                                                                            className="tab-pane fade show active"
                                                                            id="nav-Recent"
                                                                            role="tabpanel"
                                                                            aria-labelledby="nav-Recent-tab"
                                                                            tabIndex={0}
                                                                        >
                                                                            <div className="table-responsive table-datatble">
                                                                                <DataTable
                                                                                    className="table datatable"
                                                                                    value={filteredData}
                                                                                    paginator
                                                                                    rows={10}
                                                                                    rowsPerPageOptions={[10, 25, 50, 100]}
                                                                                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
                                                                                    // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                                    pageLinkSize={3}
                                                                                >
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="slNo"
                                                                                        body={slNoRender}
                                                                                        header="Sl No"
                                                                                    // headerStyle={{ backgroundColor: "#0f2a4e", color: "#FFFF" }}
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="student"
                                                                                        body={studentRender}
                                                                                        header="Student"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="scheduleDate"
                                                                                        body={dateRender}
                                                                                        header="Date"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="assessmentType"
                                                                                        body={assessmentTypeRender}
                                                                                        header="Assessment Type"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="yfhSkillsName"
                                                                                        body={skillRender}
                                                                                        header="Skill"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="yfhAssessmentResult"
                                                                                        body={resultRender}
                                                                                        header="Result"
                                                                                    ></Column>
                                                                                    <Column
                                                                                        sortable
                                                                                        headerClassName="text-uppercase"
                                                                                        field="yfhAssessmentGrade"
                                                                                        body={gradeRender}
                                                                                        header="Grade"
                                                                                    ></Column>
                                                                                    {/* <Column
                                                                                        body={detailsRender}
                                                                                    ></Column> */}
                                                                                </DataTable>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Assessment List */}
            <div
                className="modal custom-modal fade request-modal"
                id="assessment-list"
                role="dialog"
            >
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header modal-header-title">
                                <h4 className="mb-0">
                                    Assessment Details
                                </h4>
                            </div>
                            <Link
                                to="#"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            >
                                <span className="align-center" aria-hidden="true">
                                    <i className="feather-x" />
                                </span>
                            </Link>
                        </div>
                        <div className="modal-body">
                            <div className="row text-sm-end">
                                <div className="dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchQuery}
                                            onChange={(e) => setSearchQuery(e.target.value)}
                                            placeholder="Search Students"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="table-responsive table-datatble sortable">
                                    <table className="table datatable">
                                        <thead className="thead-light">
                                            <tr>
                                                <th className="text-uppercase">Sl No.</th>
                                                <th className="text-uppercase">Student Name</th>
                                                <th className="text-uppercase">Skill</th>
                                                <th className="text-uppercase">Result</th>
                                                <th className="text-uppercase">Comment</th>
                                            </tr>
                                            {Array.isArray(filteredAssessment) && filteredAssessment.map((asmnt, index) => (
                                                <tr key={index}>
                                                    <td>{index + 1}</td>
                                                    <td>{asmnt.StudentName}</td>
                                                    <td>{asmnt.skillName}</td>
                                                    <td>{asmnt.yfhAssessmentResult}</td>
                                                    <td>{asmnt.yfhAssessmentComments}</td>
                                                </tr>
                                            ))}
                                        </thead>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* /Assessment List */}

        </>
    );
};

export default assessmentReport;